module.exports = __webpack_public_path__ + "img/01.5e7fa16a.png";